<template>
  <Section 
  background="#e8e5de" 
  style="margin-bottom: 0!important; border-radius: 0!important; border-top: 2px solid #d8d5cd"
  class="cta-bottom"
  >
    <Container>

      <FadeIn class="mx-auto max-w-7xl">
        <div class="sm:text-4xl text-center">
          <div class="text-section-title">
            {{ title ? title : `Interested to find out more?` }}
          </div>
        </div>
        <p class="mt-4 text-base leading-6 text-center max-w-[600px] mx-auto">
          {{ subtitle ? subtitle : `See how Elker can help with compliance and build a culture of accountability and trust in your organisation.` }}
        </p>
        <div 
        class="mt-8 text-center"
        >
          <NuxtLink
          :to="$localePath('/book-demo')"
          class="rounded-md transition bg-[#5a6ded] border-2 border-[#3645d0] hover:bg-[#3645d0] px-3.5 py-2.5 text-sm font-semibold text-white focus:outline-none" 
          >
            Book a demo
          </NuxtLink>
          <ElementButton
          url="/pricing"
          type="ghost"
          :arrow="true"
          class="ml-4 rounded-md transition bg-transparent hover:bg-[rgba(0,0,0,0.03)] px-3.5 py-2.5 text-sm font-semibold text-[#5a6ded] focus:outline-none"
          >
            Get a quote
          </ElementButton>
        </div>
      </FadeIn>
    </Container>
  </Section>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: false
  },
  subtitle: {
    type: String,
    required: false
  }
})
</script>